import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import { OnboardingRegistrationStatus } from '@/common/viewModels/Enums';
import { RegistrationDetailsOdinRefresh } from '@/common/viewModels';
import { Button } from '@/external/telstra-ui-vue/components';

@Component({
  components: {
    Button,
  },
})
export default class RegistrationDetailsNav extends
  Vue {

  @Prop({ required: true }) status!: OnboardingRegistrationStatus;
  @Prop({ required: true }) hasOdinAccounts!: boolean;
  @Prop({ required: true }) odinDataRefresh!: RegistrationDetailsOdinRefresh;

  get showCancel(): boolean {
    return [OnboardingRegistrationStatus.Submitted, OnboardingRegistrationStatus.Error].indexOf(this.status) >= 0;
  }

  get showClose(): boolean {
    return [OnboardingRegistrationStatus.Submitted, OnboardingRegistrationStatus.Error].indexOf(this.status) === -1;
  }

  get showSubmit(): boolean {
    return this.hasOdinAccounts && [OnboardingRegistrationStatus.Submitted, OnboardingRegistrationStatus.Error].indexOf(this.status) >= 0;
  }

  get showCreate(): boolean {
    return !this.hasOdinAccounts && this.status === OnboardingRegistrationStatus.Submitted;
  }

  get submitLabel(): string {
    return this.status === OnboardingRegistrationStatus.Submitted ? 'Submit' : 'Resubmit';
  }

  @Emit()
  onCancel() {
    this.$emit('action', 'cancel');
  }

  @Emit()
  onClose() {
    this.$emit('action', 'close');
  }

  @Emit()
  onCreate() {
    this.$emit('action', 'create');
  }

  @Emit()
  onSubmit() {
    this.$emit('action', 'submit');
  }
}
